<template>
    <div id="history">
        <div class="filter">
            <div class="w100 flex">
                <div class="w100 flex pd10">
                    <div class="w10 pdlr5" title="Code nhân viên">
                        <input type="text" class="form-control" v-model="filter.code" placeholder="Code">
                    </div>
                    <div class="w20 pdlr5" title="Email nhân viên">
                        <input type="text" class="form-control" v-model="filter.email" placeholder="Email nhân viên">
                    </div>
                    <div class="w30 flex position_re ">
                        <div class="w50 pdlr5" title="Ngày">
                            <input type="date" class="form-control " v-model="filter.ds">
                        </div>
                        <div class="w50 pdlr5" title="Đến ngày">
                            <input type="date" class="form-control " v-model="filter.de">
                        </div>
                    </div>
                    <div class="w10 pdlr5">
                        <span class="btn btn-primary" @click="getLogPayment">Lọc</span>
                    </div>
                    <div class="w10 pdlr5">
                        <span class="btn btn-danger" @click="removeLog">Xóa log</span>
                    </div>
                    <div class="w20 pdlr5">
                        <a href="http://hcns.vchat.vn/send" class="btn btn-success" target="_blank">Bắt đầu gửi mail</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="listing">
            <div v-if="show_loadding" class="lloading tc pd10"><img src="@/assets/image/loading.svg"></div>
            <table class="table">
                <thead class="tbhead">
                    <tr>
                        <th width="10" class="tc">ID</th >
                        <th width="50" class="tc">Code</th >             
                        <th class="">Email</th > 
                        <th width="150">Ngày tạo</th >
                        <th width="150">Đã gửi lúc</th >
                        <th width="100">Hành động</th >
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,i) in dataLog" :key="i" :class="(item.status == 1)? 'success' : ''">
                        <td class="tc">{{item.id}}</td >
                        <td class="tc">{{item.code}}</td >
                        <td>
                            {{item.email}}
                        </td >
                        <td class=""><span class="f12">{{item.create_at}}</span></td>
                        <td class="">
                            <span v-if="item.send==1" class="badge badge-success" >Đã gửi</span>
                            <div><span class="f12">{{item.update_at}}</span></div>
                        </td >
                        <td class="tc">
                            <a :href="'http://hcns.vchat.vn/send?id=' + item.id" target="_blank"  class="badge badge-primary">Gửi lại</a>
                        </td >
                    </tr>
                </tbody>
            </table>
            <div class="pdlr10 footerlist">
                <div class="w50 inblock">
                    <b>{{total_record}}</b> Bản ghi | Trang <b>{{current_page}}</b>
                </div>
                <div class="w50 tr inblock">
                    <div class="page" v-if="dataPage.total_pages > 1">
                        <span class="ipage inblock pdlr10 pdtb5 lh33" v-for="(ipage, i) in page" :key="i" :title="ipage.title" :class="ipage.class" @click="getLogPayment(ipage.page)">{{ipage.name}}</span>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {callApi, generate_page} from '@/helper/function'
import {mapGetters} from 'vuex'
import Axios from 'axios'
export default {
    name : 'chat',
    data () {
        return {
            dataLog: {},
            dataPage: {},
            current_page: 1,
            per_page: 10,
            total_record: 0,
            show_loadding: false,
            total_payment: 0,
            page: [],
            /** filter */
            filter: {
                code: 0, // id tài khoản khách hàng
                email: '', // id nhân viên kinh doanh
                ds: '', // ngày kích hoạt từ
                de: '' // ngày kích hoạt đến
            }
        }
    },
    computed: {
        ...mapGetters(['getUser'])
    },
    created() {
        this.getLogPayment()
    },
    methods: {


        /** lấy danh sách người dùng đăng ký để sale gọi điện và tìm kiếm */
        getLogPayment(idx){      
            this.show_loadding = true      
            let page = 1
            if(idx > 0){
                page = idx
            }
            let fillter = '?page='+page

            if(this.filter.code > 0) fillter +='&code='+this.filter.code
            if(this.filter.email != '') fillter +='&e='+this.filter.email
            if(this.filter.ds != '') fillter +='&ds='+this.filter.ds
            if(this.filter.de != '') fillter +='&de='+this.filter.de

            callApi('/log'+fillter, '', 'GET')
            .then((res) => {
                let data = res.data
                let code = data.code
                this.show_loadding = false
                if(code == 200){
                    this.dataLog = Object.assign({}, data.data.data)
                    this.dataPage =  Object.assign({},data.data.meta.pagination)
                    this.current_page = parseInt(this.dataPage.current_page)
                    this.per_page = parseInt(this.dataPage.per_page)
                    this.total_record = parseInt(this.dataPage.total)
                    this.page = []
                    this.page = generate_page(this.dataPage)
                    
                }else{
                    this.$store.commit('set_alert_msg_error','[Get log]: ' +  data.error)
                }
            }).catch((err) => {
                this.$store.commit('set_alert_msg_error','[Get log]: ' +  err)
            })
        },

        /** lọc cuộc chat */
        fillterUser(){
            this.getLogPayment()
        },

        removeLog(){
            callApi('/log', '', 'DELETE')
            .then((res) => {
                let response = res.data
                let code = response.code
                if(code == 200){
                    this.getLogPayment()
                }
            })
        }


    },
}
</script>
<style>
#history{
    height: 100%;
    overflow: auto;
}
.filter_group{
    border-radius: 3px;
    padding: 10px 5px 8px 5px;
    margin-right: 10px;
    border: 1px solid #616161;
}
.filter_label{
    position: absolute;
    top: -8px;
    left: 5px;
    background-color: #fff;
    font-size: 11px;
    padding: 0 5px;
    border-radius: 10px;
}
.success{
    background-color: #A6EAB5;
}
</style>
